import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { motion } from "motion/react";
import Core from "../Components/Core";

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />

      {/* PRIVACY POLICY CONTENT */}
      <section className="bg-white pt-lg-8 pt-6 pb-lg-8 pb-6 px-lg-6 px-4">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">

              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <div className="fs-1 fw-bold text-dark mb-4 text-center">
                  Privacy Policy
                </div>

                <div className="fs-4 text-dark text-justify">

                  <p>
                    At Ebun Heritage Schools, we are committed to protecting 
                    the privacy and personal information of our students, 
                    parents, staff, alumni, and website visitors. This Privacy 
                    Policy explains how we collect, use, and safeguard your information.
                  </p>

                  <br />

                  <span className="fw-semibold">1. Information We Collect</span>
                  <p>
                    We may collect personal information including names, 
                    phone numbers, email addresses, residential addresses, 
                    academic records, and other relevant details provided 
                    through admission forms, employment applications, 
                    website inquiries, or official communications.
                  </p>

                  <br />

                  <span className="fw-semibold">2. How We Use Your Information</span>
                  <p>
                    The information collected is used to:
                    <br />
                    ✔ Process student admissions <br />
                    ✔ Manage academic records <br />
                    ✔ Communicate with parents and guardians <br />
                    ✔ Respond to inquiries and applications <br />
                    ✔ Improve our educational services
                  </p>

                  <br />

                  <span className="fw-semibold">3. Data Protection & Security</span>
                  <p>
                    We implement appropriate administrative and technical 
                    measures to protect your personal data from unauthorized 
                    access, disclosure, alteration, or destruction.
                  </p>

                  <br />

                  <span className="fw-semibold">4. Sharing of Information</span>
                  <p>
                    Ebun Heritage Schools does not sell, trade, or rent 
                    personal information to third parties. Information may 
                    only be shared when required by law or with authorized 
                    educational and regulatory bodies.
                  </p>

                  <br />

                  <span className="fw-semibold">5. Cookies & Website Usage</span>
                  <p>
                    Our website may use basic cookies to enhance user 
                    experience and analyze website traffic. You may disable 
                    cookies through your browser settings if preferred.
                  </p>

                  <br />

                  <span className="fw-semibold">6. Your Rights</span>
                  <p>
                    You have the right to request access, correction, or 
                    deletion of your personal information held by the school, 
                    subject to applicable laws and regulations.
                  </p>

                  <br />

                  <span className="fw-semibold">7. Policy Updates</span>
                  <p>
                    This Privacy Policy may be updated periodically. Any 
                    changes will be communicated through our official website.
                  </p>

                  <br />

                  <span className="fw-semibold">8. Contact Us</span>
                  <p>
                    If you have any questions regarding this Privacy Policy 
                    or how your information is handled, please contact us at:
                    <br /><br />
                    <span className="fw-semibold">
                      101, Liasu Road, Egbe-Idimu, Lagos.
                    </span>
                  </p>

                </div>
              </motion.div>

            </div>
          </div>
        </div>
      </section>

      <Core />
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
